import React from 'react';
import { Spinner, Wrapper } from './styles';

type LoadingProps = {
  size?: number;
  color?: string;
  fullWidth?: boolean;
};

const Loading = (props: LoadingProps) => {
  const { size = 40, color = '#262ba6', fullWidth = true } = props;

  return (
    <Wrapper fullWidth={fullWidth}>
      <Spinner size={size} color={color} />
    </Wrapper>
  );
};

export default Loading;
